import Contact, { IContact, IContactApiModel } from './Contact.model';

export interface IProductContact {
  id: number;
  contactId: string;
  contact: IContact;
}

export interface IProductContactApiModel {
  id: number;
  contactId: string;
  contact: IContactApiModel;
}

export default class ProductContact implements IProductContact {
  public readonly id: number;

  public readonly contactId: string;

  public readonly contact: IContact;

  constructor(id: number, contactId: string, contact: IContact) {
    this.id = id;
    this.contactId = contactId;
    this.contact = contact;
  }

  static fromApiModel(apiModel: IProductContactApiModel) {
    const { id, contactId } = apiModel;

    const contact = Contact.fromApiModel(apiModel.contact);

    return new ProductContact(id, contactId, contact);
  }

  static arrayFromApiModel(arrayApiModel: IProductContactApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, contactId } = apiModel;

      const contact = Contact.fromApiModel(apiModel.contact);

      return new ProductContact(id, contactId, contact);
    });

    return array;
  }
}
